import { SalesClaims } from './auth-contracts';

export type SalesRole = 'SALES_REP' | 'MLG_SALES_REP';

/** Reads a claim as the API does: a JSON boolean, or "true"/"false" in any case. Anything else is null. */
export function readFlag(value: unknown): boolean | null {
  if (typeof value === 'boolean') {
    return value;
  }

  if (typeof value === 'string') {
    const normalized = value.trim().toLowerCase();

    if (normalized === 'true') {
      return true;
    }

    if (normalized === 'false') {
      return false;
    }
  }

  return null;
}

/** Mirrors the API's SalesRepFull policy. A missing or unreadable MLG claim counts as MLG, so it fails closed. */
export function roleOf(claims: SalesClaims): SalesRole {
  if (readFlag(claims.adminView) === true) {
    return 'SALES_REP';
  }

  return readFlag(claims.isMLGSalesRep) === false ? 'SALES_REP' : 'MLG_SALES_REP';
}
